import { BrowserRouter as Router } from 'react-router-dom';
import { AuthProvider } from '@/contexts/AuthContext';
import { BrandOffersAdminAuthProvider } from '@/contexts/BrandOffersAdminAuthContext';
import './App.css';
import { type JSX } from 'react';
import { AppWithSplash } from './components/layout';
import usePostHogPageview from './hooks/usePostHogPageview';
import AppRoutes from './routes/AppRoutes';
import { fetchCategories } from './services/slaydAPI';

function AppContent(): JSX.Element {
  usePostHogPageview();
  return (
    <main>
      <AppRoutes />
    </main>
  );
}

function App(): JSX.Element {
  fetchCategories();
  return (
    <AuthProvider>
      <Router>
        <BrandOffersAdminAuthProvider>
          <AppWithSplash>
            <AppContent />
          </AppWithSplash>
        </BrandOffersAdminAuthProvider>
      </Router>
    </AuthProvider>
  );
}

export default App;
